import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CachingService } from 'src/app/services/caching.service';
import { CallAPIService } from 'src/app/services/call-api.service';
import { TopListComponent } from '../top-list/top-list.component';
@Component({
  selector: 'app-top-department-service',
  templateUrl: 'top-department-service.component.html',
  styleUrls: ['top-department-service.component.scss'],
})
export class TopDepartmentService implements OnInit {
  public deptServiceList: any;
  @Input() isDepartment!: boolean;
  @Input() deptResp!: any[];
  @Input() serviceResp!: any[];
  constructor(
    private dialog: MatDialog
  ) {
    
  }
  ngOnInit(): void {
  }

  ngOnChanges() {
    // if(this.isDepartment)this.getStats();
    // else this.getServiceStats();
  }

  

  // getStats() {
  //   this.apiService.getTopDepartment().subscribe({
  //     next: (resp: any) => {
  //       this.deptServiceList = { ...resp[1] }
  //       this.cacheService.storeDashboardData('twentyStats', this.deptServiceList)
  //     },
  //     error: (err: any) => {
  //       this.deptServiceList = this.cacheService.fetchDashboardData('twentyStats')
  //     }
  //   })
  //   if(this.deptServiceList) this.deptServiceList['data'] = this.sortArray(this.deptServiceList?.data)
  //  }

  // getServiceStats() {
  //   this.apiService.getTopServices().subscribe({
  //     next: (resp: any) => {
  //       this.deptServiceList = { ...resp[1] }
  //       this.cacheService.storeDashboardData('twentyserviceStats', this.deptServiceList)
  //     },
  //     error: (err: any) => {
  //       this.deptServiceList = this.cacheService.fetchDashboardData('twentyserviceStats')
  //     }
  //   })
  //   if(this.deptServiceList) this.deptServiceList['data'] = this.sortArray(this.deptServiceList?.data)
  // }

  sortArray(array: any) {
    return array?.sort((a: any, b: any) => b?.totaltxn - a?.totaltxn);
  }

  viewAll(type: string) {
    this.dialog.open(TopListComponent, {
      data: {
        list: this.deptServiceList,
        department: type == 'dept' ? true : false,
      },
      width: '380px',
    });
  }
}
